export const mockData = {
  hero: {
    tagline: "Melbourne's independent crime news outlet cutting through the corporate spin to deliver raw, unfiltered reporting on the underworld.",
    subtitle: "From Melbourne's gangland conflicts to the bloody tobacco wars - we give you the truth straight from the streets."
  },
  
  stats: [
    { value: "16M+", label: "Monthly Social Views" },
    { value: "500K+", label: "Monthly Readers" },
    { value: "Daily", label: "Updates" },
    { value: "100%", label: "Independent" }
  ],

  services: [
    {
      icon: "FileText",
      title: "Hard-Hitting Written Reports",
      description: "Breaking news, deep dives, and exclusive investigations. The stories mainstream media either sanitise, ignore, or get completely wrong.",
      platform: "Read on Outlaw Media"
    },
    {
      icon: "Mic",
      title: "The Outlaw Media Podcast",
      description: "No-holds-barred conversations with insiders, ex-criminals, investigators, and those who've lived the life. Raw, authentic, unfiltered.",
      platform: "Apple | Spotify | YouTube"
    },
    {
      icon: "Instagram",
      title: "Daily Underworld Updates",
      description: "Fast, factual, zero filter coverage across Instagram. Breaking news from Melbourne's criminal landscape as it happens.",
      platform: "@ryannaumenko"
    },
    {
      icon: "Shield",
      title: "Insider Access & Sources",
      description: "Real relationships built over years in Victoria's criminal landscape. We don't just report the news - we know the players, the history, and the streets.",
      platform: "Exclusive Coverage"
    }
  ],

  about: {
    intro: "Outlaw Media is an independent crime news outlet and podcast, founded and run by Ryan Naumenko. Headquartered in Dubai, United Arab Emirates, reporting from Melbourne, Australia.",
    paragraphs: [
      "We cut through the corporate spin and deliver raw, unfiltered reporting on Melbourne's underworld - the stories mainstream media either sanitise, ignore, or get completely wrong.",
      "From Melbourne's ongoing gangland conflicts and the bloody tobacco wars to organised crime, high-profile hits, court cases, and the real faces behind the headlines, Outlaw Media gives you the truth straight from the streets.",
      "Outlaw Media exists for one reason: to give Melburnians the unpolished, authentic coverage of crime and justice that actually matters. No suits, no spin, no agenda - just the facts, the context, and the voices that matter."
    ],
    location: "Dubai HQ · Reporting from Melbourne"
  },

  social: {
    instagram1: "https://instagram.com/ryannaumenko",
    instagram2: "https://instagram.com/ryannaumenko",
    youtube: "https://youtube.com/@ryan.naumenko",
    podcast: {
      apple: "https://podcasts.apple.com",
      spotify: "https://spotify.com",
      youtube: "https://youtube.com/@ryan.naumenko"
    }
  }
};
